import axios from "axios";
import React, { useEffect, useState } from "react";
import { apiKey } from "../config/config";
import { convertDateFormat } from "../services/helper";

function VerifyCustomer({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const [formData, setForMData] = useState({
    validId: "",
  });
  const [customerData, setCustomerData] = useState([]);
  const [contractData, setContractData] = useState([]);
  const [isActiveContracts, setIsActiveContracts] = useState(1);
  const handleChange = (e) =>
    setForMData({ ...formData, [e.target.name]: e.target.value });

  const handleVerify = (e) => {
    e.preventDefault();

    axios
      .post(`${apiKey}/verify-customer`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setCustomerData(res.data.customer);
        setContractData(res.data.contracts);
        setIsActiveContracts(res.data.status);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    const modalEl = document.getElementById("verifycustomer");

    const handleModalClose = () => {
      setForMData({
        validId: "",
      });
      setCustomerData([]);
    };

    modalEl.addEventListener("hidden.bs.modal", handleModalClose);

    return () => {
      modalEl.removeEventListener("hidden.bs.modal", handleModalClose);
    };
  }, []);
  return (
    <div className="modal fade" id="verifycustomer" tabIndex="-1">
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content">
          <div>
            <div className="modal-header">
              <h4 className="modal-title" id="myModalLabel">
                {lang?.verify_customer || "Verify Customer"}
              </h4>
              <button
                type="button"
                className="btn-close btn"
                data-bs-toggle="modal"
                data-bs-target="#verifycustomer"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row justify-content-between w-100">
                <div className="col-md-4 col-lg-3">
                  <a
                    href="https://www.absher.sa/wps/portal/individuals/Home/homepublic/!ut/p/z1/04_Sj9CPykssy0xPLMnMz0vMAfIjo8ziDTxNTDwMTYy83Q3MjAwcw4IsTFw9TQ3dzUz0wwkpiAJJ4wCOBkD9UViUOBo4BRk5GRsYuPsbYVWAYkZBboRBpqOiIgBIR9Vv/dz/d5/L0lDUmlTUSEhL3dHa0FKRnNBLzROV3FpQSEhL2Fy/"
                    target="_blank"
                    className="btn-cancel btn"
                    rel="noreferrer"
                  >
                    <img
                      src="/img/absherlogo.svg"
                      width={48}
                      height={48}
                      alt=""
                    />
                  </a>
                </div>
                <div className="col-md-4 col-lg-3">
                  <a
                    href="https://new.najiz.sa/applications/landing"
                    target="_blank"
                    className="btn-cancel btn"
                    rel="noreferrer"
                  >
                    <img
                      src="/img/Najizlogo.svg"
                      width={48}
                      height={48}
                      alt=""
                    />
                  </a>
                </div>
                <div className="col-md-4 col-lg-3">
                  <a
                    href="https://www.gosi.gov.sa/ar"
                    target="_blank"
                    className="btn-cancel btn"
                    rel="noreferrer"
                  >
                    <img
                      src="/img/GOSIlogo.png"
                      width={48}
                      height={48}
                      alt=""
                    />
                  </a>
                </div>
              </div>
              <div>
                <p className="text-center fw-semibold mt-5">OR</p>
              </div>
              <div>
                <form onSubmit={handleVerify}>
                  <div className="row mb-3 mt-5 d-flex justify-content-center">
                    <div className="col-10">
                      <label htmlFor="expenseCategory" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Customer_ValidId ||
                            "Customer Valid Identity Number"}
                        </span>
                        <input
                          id="expenseCategory"
                          type="text"
                          className="form-control"
                          value={formData.validId}
                          name="validId"
                          onChange={handleChange}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="text-center mb-5">
                    <button type="submit" className="btn-primary btn">
                      {lang.Search || "Search"}
                    </button>
                  </div>
                </form>
                {contractData?.length === 0 ? (
                  isActiveContracts === 0 ? (
                    <h4 className="text-center text-danger">
                      {lang.No_active_contracts ||
                        "Customer does not have any active contracts"}
                    </h4>
                  ) : (
                    <h4 className="text-center text-danger">
                      {lang.Customer_not_exists || "Customer does not exist"}
                    </h4>
                  )
                ) : (
                  <>
                    <h4>{lang.Customer || "Customer"}:</h4>
                    <p>{customerData?.FullName}</p>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>{lang.Contract_No || "Contract No"}</th>
                          <th>{lang.Amount || "Amount"}</th>
                          <th>{lang.Date_of_payment || "Date of payment"}</th>
                          <th>{lang.Due_Date || "Due Date"}</th>
                          <th>{lang.Status || "Status"}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {contractData?.map((item, idx) => (
                          <tr key={idx}>
                            <td>{item?.contract_form_number}</td>
                            <td>{item.total_value}</td>
                            <td>{convertDateFormat(item?.receipt?.date)}</td>
                            <td>
                              {convertDateFormat(item.date_1st_installment)}
                            </td>
                            <td>
                              {" "}
                              {parseInt(item.status) === 1 ? (
                                <span className="badge rounded-pill bg-success">
                                  {lang.active || "Active"}
                                </span>
                              ) : parseInt(item.status) === 2 ? (
                                <span className="badge rounded-pill bg-primary">
                                  {lang.completed || "Completed"}
                                </span>
                              ) : parseInt(item.status) === 3 ? (
                                <span className="badge rounded-pill bg-danger">
                                  {lang.defaulted || "Defaulted"}
                                </span>
                              ) : (
                                <span className="badge rounded-pill bg-warning">
                                  {lang.no_contract || "No Contract"}
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyCustomer;
